import { Card, Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';

const testimonials = [
  {
    name: 'Jennifer Lewis',
    text: 'Fast shipping and excellent customer service. The product was even better than expected. I will definitely be a returning customer.',
    img: 'https://randomuser.me/api/portraits/women/65.jpg',
  },
  {
    name: 'Alicia Heart',
    text: 'Great user experience on your website. I found exactly what I was looking for at a great price. I will definitely be telling my friends.',
    img: 'https://randomuser.me/api/portraits/women/66.jpg',
  },
  {
    name: 'Juan Carlos',
    text: 'Thank you for the excellent shopping experience. It arrived quickly and was exactly as described. I will definitely be shopping with you again in the future.',
    img: 'https://randomuser.me/api/portraits/men/67.jpg',
  },
];

const Testimonials = () => {
  return (
    <Container className="my-5">
      <h2 className="text-center fw-bold mb-4">WHAT OUR CUSTOMERS SAY</h2>
      <Row>
        {testimonials.map((item, index) => (
          <Col key={index} md={4} className="mb-4">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ scale: 1.03 }}
            >
              <Card className="h-100 shadow-sm border-0">
                <Card.Body>
                  <Card.Text className="fst-italic">“{item.text}”</Card.Text>
                </Card.Body>
                <Card.Footer className="bg-white border-0 d-flex align-items-center">
                  <img
                    src={item.img}
                    alt={item.name}
                    className="rounded-circle me-3"
                    width="50"
                    height="50"
                  />
                  <div className="fw-bold text-uppercase">{item.name}</div>
                </Card.Footer>
              </Card>
            </motion.div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Testimonials;
